// extracted by mini-css-extract-plugin
export default {"title":"title--sqomm","rich-text-content":"rich-text-content--TPurP","richTextContent":"rich-text-content--TPurP","blink":"blink--Y4H46"};